var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import Text from "../Text/Text";
var StyledList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.75rem 0 0 0;\n  padding: 0 0 0 2rem;\n  font-family: \"Lato\", sans-serif;\n  list-style-type: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.75rem 0 0 0;\n  padding: 0 0 0 2rem;\n  font-family: \"Lato\", sans-serif;\n  list-style-type: ", ";\n"])), function (props) {
    return props.$variant === "ordered"
        ? "decimal"
        : props.$variant === "unordered"
            ? "disc"
            : "none";
});
var Title = function (title, size) {
    if (!title)
        return null;
    return typeof title === "string" ? (_jsx(Text, __assign({ variant: "paragraph", size: size }, { children: title }))) : (title);
};
var List = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.variant, variant = _b === void 0 ? "ordered" : _b, size = _a.size, containerStyle = _a.containerStyle, style = _a.style, className = _a.className;
    return (_jsxs("div", __assign({ style: containerStyle }, { children: [Title(title, size), _jsx(StyledList, __assign({ "$variant": variant, style: style, className: className }, { children: children }))] })));
};
export default List;
var templateObject_1;
